module.exports = __webpack_public_path__ + "static/media/whatsapp.fc05d72f.png";